import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../components/ThemeComponent/ThemeDataTable";
import ThemePagination from "../components/ThemeComponent/ThemePagination";
import ThemeSearchInput from "../components/ThemeComponent/ThemeSearchInput";
import ThemeSort from "../components/ThemeComponent/ThemeSort";
import { PageHeading } from "../components/ThemeComponent/ThemeText";
import { useDeleteClientMutation, useGetClientsQuery } from "../Redux/services/adminApi.js";
import AddClient from "../components/modals/AddClient";
import ThemeModal from "../components/ThemeComponent/ThemeModal";
import RemoveModal from "../components/modals/RemoveModal";
import ThemeAddButton from "../components/ThemeComponent/ThemeAddButton";
import { success } from "../utils/helpers.js";

const DashBoard = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const selectedData = useSelector((state) => state.selectedData.value);
  const [selectedValue, setSelectedValue] = useState("Client Name");
  const [modalData, setModalData] = useState(null);
  const [visiblePasswordRow, setVisiblePasswordRow] = useState(null);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(''); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [searchQuery, setSearchQuery] = useState("");

  const options = [
    { value: "client_name", label: "Client Name" },
    { value: "phone", label: "Phone" },
    { value: "address", label: "Address" },
  ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetClientsQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: page,
        sort_by: selectedValue,
      },
      { refetchOnMountOrArgChange: true }
    );
  const [deleteClient, { isLoading: deleteLoading }] = useDeleteClientMutation();


  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleTogglePassword = (rowIndex) => {
    setVisiblePasswordRow((prevIndex) =>
      prevIndex === rowIndex ? null : rowIndex
    );
  };

  const onRemoveClick = async () => {
    await deleteClient({id: modalData.id});
    setTimeout(() => {
      setRemoveOpen(false);
      success("Successfully Removed");
      refetch();
    }, 500);
  };

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setPage(data.links.current);
      setTotalRecords(data.links.total_records === 0 ? '' : data.links.total_records);
      setTotalPages(data.links.total);
      // setRowData(data.data);
    }
  }, [data]);

  const header = [
    {
      title: "Client Name",
      dataIndex: "name",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    {
      title: "Address",
      dataIndex: "address",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    {
      title: "Phone",
      dataIndex: "mobile_no",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    {
      title: "Email",
      dataIndex: "email",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    // {
    //   title: "User Name",
    //   dataIndex: "username",
    //   style: { textAlign: "left" },
    //   elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    // },
    {
      title: "Password",
      dataIndex: "password_view",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return (
          <div className="cursor" onClick={() => handleTogglePassword(index)}>
            {visiblePasswordRow === index
              ? rowData?.password_view
              : "*".repeat(rowData?.password_view?.length)}
          </div>
        );
      },
    },
    ,
    {
      title: "Notes",
      dataIndex: "notes",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
  ];

  // const data = [
  //   {
  //     slug: 1,
  //     client_name: "Cameron Williamson",
  //     address: "8080 Railroad St.",
  //     phone: "(603) 555-0123",
  //     email: "nathan.roberts@example.com",
  //     username: "username1893",
  //     password: "3847rhs5",
  //     notes: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //   },
  //   {
  //     slug: 2,
  //     client_name: "Floyd Miles",
  //     address: "775 Rolling Green Rd.",
  //     phone: "(209) 555-0104",
  //     email: "debbie.baker@example.com",
  //     username: "username1442",
  //     password: "6666dg",
  //     notes: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //   },
  //   {
  //     slug: 3,
  //     client_name: "Annette Black",
  //     address: "8558 Green Rd.",
  //     phone: "(704) 555-0127",
  //     email: "debbie.lawson@example.com",
  //     username: "username1123",
  //     password: "5894baby",
  //     notes: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //   },
  //   {
  //     slug: 4,
  //     client_name: "Theresa Webb",
  //     address: "7529 E. Pecan St.",
  //     phone: "(808) 555-0111",
  //     email: "novah.simmons@example.com",
  //     username: "username1563",
  //     password: "1234567890",
  //     notes: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //   },
  //   {
  //     slug: 5,
  //     client_name: "Kathryn Murphy",
  //     address: "775 Rolling Green Rd.",
  //     phone: "(307) 555-0133",
  //     email: "jessica.hanson@example.com",
  //     username: "username1893",
  //     password: "4682347jk",
  //     notes: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //   },
  //   {
  //     slug: 6,
  //     client_name: "Brooklyn Simmons",
  //     address: "7592 E. Pecan St.",
  //     phone: "(702) 555-0122",
  //     email: "felicia.reid@example.com",
  //     username: "username1128",
  //     password: "772123",
  //     notes: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //   },
  //   {
  //     slug: 7,
  //     client_name: "Robert Fox",
  //     address: "3605 Parker Rd.",
  //     phone: "(252) 555-0125",
  //     email: "tim.jennings@example.com",
  //     username: "username1353",
  //     password: "37737ups",
  //     notes: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //   },
  //   {
  //     slug: 8,
  //     client_name: "Dianne Russell",
  //     address: "3890 Poplar Dr.",
  //     phone: "(201) 555-0124",
  //     email: "curtis.weaver@example.com",
  //     username: "username218",
  //     password: "4724xyz374929",
  //     notes: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //   },
  //   {
  //     slug: 9,
  //     client_name: "Leslie Alexander",
  //     address: "3605 Parker Rd.",
  //     phone: "(319) 555-0115",
  //     email: "michelle.rivera@example.com",
  //     username: "username1001",
  //     password: "jclikkkkkkk",
  //     notes: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //   },
  //   {
  //     slug: 10,
  //     client_name: "Devon Lane",
  //     address: "8080 Railroad St.",
  //     phone: "(207) 555-0119",
  //     email: "dolores.chambers@example.com",
  //     username: "username1232",
  //     password: "25252dg",
  //     notes: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  //   },
  // ];

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1500);
  }, [page]);


  return (
    <div className="dashboard-page">
      <div className="header d-flex justify-content-between">
        <PageHeading text={"Clients"} count={totalRecords} />
        <div className="d-flex responsive-flex align-items-center gap-3 ms-auto">
          <ThemeAddButton
            text={"Add Client"}
            onClick={() => {
              setShowAdd(true);
              setModalData(null);
            }}
            className={"responsive-margin"}
          />
          <ThemeSort
            selectedValue={selectedValue}
            handleChange={handleChange}
            options={options}
          />
          <ThemeSearchInput setSearchQuery={setSearchQuery} />
        </div>
      </div>
      <div className="table-content mt-2">
        <Table
          header={header}
          data={data?.data}
          loading={isLoading}
          removeText="Client"
          onEditClick={() => setShowEdit(true)}
          setModalData={setModalData}
          setRemoveOpen={() => setRemoveOpen(true)}
        />
      </div>
      <div className="pagination mt-3">
        {/* {!loading && ( */}
          <ThemePagination
            activePage={page}
            totalPages={totalPages}
            setPage={setPage}
            page={page}
          />
        {/* )} */}
        {showEdit && (
          <ThemeModal
            size={"md"}
            modalContent={
              <AddClient
                setIsOpen={setShowEdit}
                modalData={modalData}
                refetch={refetch}
              />
            }
            title={"Update Client"}
            className={"edit-profile"}
            isOpen={showEdit}
            setIsOpen={setShowEdit}
          />
        )}
        {showAdd && (
          <ThemeModal
            size={"md"}
            modalContent={
              <AddClient
                setIsOpen={setShowAdd}
                modalData={modalData}
                refetch={refetch}
              />
            }
            title={"Add Client"}
            className={"edit-profile"}
            isOpen={showAdd}
            setIsOpen={setShowAdd}
          />
        )}
        {removeOpen && (
          <ThemeModal
            size={"sm"}
            modalContent={
              <RemoveModal
                setIsOpen={setRemoveOpen}
                modalData={modalData}
                refetch={refetch}
                onRemoveClick={onRemoveClick}
                isLoading={deleteLoading}
              />
            }
            title={""}
            className={"edit-profile"}
            isOpen={removeOpen}
            setIsOpen={setRemoveOpen}
          />
        )}
      </div>
    </div>
  );
};

export default DashBoard;
